import './ComparisonTable.css';
import React, { useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get } from '../../utils';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Select from "react-select";
import { tealiumClickFunc } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
const MAX_TABLET_WIDTH = "974px";
const getCountOfColumns = variant => {
  switch (variant) {
    case "Two Columns":
      return 2;
    case "Three Columns":
      return 3;
    case "Four Columns":
      return 4;
    default:
      return 0;
  }
};
const sortItems = (targetItems, compareItems) => {
  const priorityMap = new Map(targetItems.map((item, index) => [item.id, index]));
  const sortedItems = compareItems.sort((a, b) => {
    const priorityIndexA = priorityMap.get(a.id);
    const priorityIndexB = priorityMap.get(b.id);
    if (priorityIndexA !== undefined && priorityIndexB !== undefined) {
      return priorityIndexA - priorityIndexB;
    } else if (priorityIndexA !== undefined) {
      return -1;
    } else if (priorityIndexB !== undefined) {
      return 1;
    } else {
      return a.name.localeCompare(b.name);
    }
  });
  return sortedItems;
};
const ComparisonTable = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const count = getCountOfColumns(params.variant);
  const targetItems = get(fields, "data.item.compare.targetItems", []).filter(el => get(el, "comparisonName.jss.value"));
  const items = get(fields, "data.item.children", []).filter(el => get(el, "comparisonName.jss.value"));
  const slicedTargetItems = sortItems(targetItems, items).slice(0, count);
  const [selectedItems, setSelectedItems] = useState(slicedTargetItems.map(el => ({
    value: el.id,
    label: el.comparisonName.jss.value
  })));
  const getSelectedItem = index => {
    return items.find(el => el.id === selectedItems[index].value);
  };
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const rowsNames = Array.from(Array(10).keys()).map(num => {
    return get(fields, `data.item.rowTitle${num + 1}.jss.value`, "");
  });
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `comparison-table comparison-table__${targetItems.length}-items module-group`
  }, items.length > 1 && rowsNames.some(el => el) && /*#__PURE__*/React.createElement("div", null, items.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: `comparison-table__selects ${items.length === slicedTargetItems.length ? "comparison-table__selects--desktop-hidden" : ""}`
  }, slicedTargetItems.map((_, i) => /*#__PURE__*/React.createElement(Select, {
    key: i,
    value: selectedItems[i],
    name: `comparison-table-${i}`,
    id: `comparison-table-${i}`,
    options: items.map(el => ({
      label: el.comparisonName.jss.value,
      value: el.id
    })),
    className: "comparison-table__select",
    classNamePrefix: "select-dropdown",
    onChange: el => setSelectedItems(selectedItems.map((item, j) => {
      if (i === j) {
        if (el) {
          tealiumClickFunc({
            eventAct: eventsAnalytics["dropDownClickAnalytics"].eventAct || params.eventAct,
            eventCat: eventsAnalytics["dropDownClickAnalytics"].eventCat || params.eventCat,
            eventLab: eventsAnalytics["dropDownClickAnalytics"].eventLab || params.eventLab,
            eventName: eventsAnalytics["dropDownClickAnalytics"].eventName || params.eventName
          }, el.label);
          return el;
        } else {
          return {
            label: "",
            value: ""
          };
        }
      } else if (el && el.value === item.value) {
        return selectedItems[i];
      } else {
        return item;
      }
    })),
    isMulti: false
  }))), items.length === slicedTargetItems.length && /*#__PURE__*/React.createElement("div", {
    className: `comparison-table__item-headers ${slicedTargetItems.length !== 2 ? "comparison-table__item-header--mobile-hidden" : ""}`
  }, selectedItems.map((selectedItem, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: "comparison-table__static-item-name"
  }, selectedItem.label))), /*#__PURE__*/React.createElement("table", {
    className: "comparison-table__table"
  }, /*#__PURE__*/React.createElement("colgroup", null, slicedTargetItems.map((_, i) => /*#__PURE__*/React.createElement("col", {
    key: i,
    className: `comparison-table__col-${i}`
  }))), /*#__PURE__*/React.createElement("tbody", null, rowsNames.map((rowName, i) => {
    return rowName ? /*#__PURE__*/React.createElement("tr", {
      key: i,
      className: `comparison-table__row`
    }, selectedItems.map((_, j) => /*#__PURE__*/React.createElement("td", {
      key: j,
      className: "comparison-table__cell"
    }, rowName && /*#__PURE__*/React.createElement("div", {
      className: "comparison-table__info-label"
    }, rowName), getSelectedItem(j)[`row${i + 1}`].jss.value ? /*#__PURE__*/React.createElement(RichText, {
      field: getSelectedItem(j)[`row${i + 1}`].jss,
      className: "comparison-table__info",
      tag: "div"
    }) : "—"))) : null;
  }), /*#__PURE__*/React.createElement("tr", {
    className: "comparison-table__btns-row"
  }, selectedItems.map((_, i) => /*#__PURE__*/React.createElement("td", {
    key: i,
    className: `comparison-table__cell`
  }, getSelectedItem(i).cTALink.jss.value.href && getSelectedItem(i).ctaLabel.jss.value && /*#__PURE__*/React.createElement("a", {
    href: getSelectedItem(i).cTALink.jss.value.href,
    onClick: () => tealiumClickFunc({
      eventAct: eventsAnalytics["buttonClickAnalytics"].eventAct || params.eventAct,
      eventCat: eventsAnalytics["buttonClickAnalytics"].eventCat || params.eventCat,
      eventLab: eventsAnalytics["buttonClickAnalytics"].eventLab || params.eventLab,
      eventName: eventsAnalytics["buttonClickAnalytics"].eventName || params.eventName
    }, [selectedItems[i].label, getSelectedItem(i).ctaLabel.jss.value]),
    className: "btn btn-primary"
  }, getSelectedItem(i).ctaLabel.jss.value)))))))));
};
export default ComparisonTable;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
const commonStyles = "c1kc4jvl";
const rtlStyles = "r1pmso1a";
const ltrStyles = "l12sjoj3";